import React, { useState, useEffect } from "react";
import "./DebugPage.scss";
import { PulseButton, PulseCheckbox } from "@pulselabs-ai/shared-fe-ui";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { resetOnboarding } from "../../store/slices/onboardingSlice";
import {
  setEnableLogging,
  setDisableAuthRedirect,
  selectDebugSettings,
} from "../../store/slices/debugSlice";
import * as Icons from "../../components/icons";

const DebugPage: React.FC = () => {
  const [mounted, setMounted] = useState(false);
  const dispatch = useDispatch();
  const appState = useSelector((state: RootState) => state);
  const { enableLogging, disableAuthRedirect } =
    useSelector(selectDebugSettings);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null; // or a loading spinner
  }

  //   const exampleCode = `
  // // Example React component
  // const MyComponent = () => {
  //   const [count, setCount] = useState(0);

  //   useEffect(() => {
  //     console.log('Count changed:', count);
  //   }, [count]);

  //   return (
  //     <div className="container">
  //       <h1>Counter: {count}</h1>
  //       <button onClick={() => setCount(count + 1)}>
  //         Increment
  //       </button>
  //     </div>
  //   );
  // };
  // `;

  const handleResetOnboarding = () => {
    dispatch(resetOnboarding());
  };

  const handleLogState = () => {
    console.log("App State:", appState);
  };

  return (
    <div className="debug-page">
      <h1>Debug Tools</h1>

      <section className="debug-section">
        <h2>Debug Actions</h2>
        <div className="debug-actions">
          <PulseButton onClick={handleResetOnboarding}>
            Reset Onboarding
          </PulseButton>
          <PulseButton onClick={handleLogState}>Log App State</PulseButton>
        </div>
      </section>

      {/* <section className="debug-section">
        <h2>PulseCode Component</h2>
        <div className="component-demo">
          <h3>Default JavaScript Example</h3>
          <PulseCode>{exampleCode}</PulseCode>

          <h3>TypeScript Example</h3>
          <PulseCode language="typescript">
            {`interface User {
  id: number;
  name: string;
  email?: string;
}

const getUser = async (id: number): Promise<User> => {
  const response = await fetch(\`/api/users/\${id}\`);
  return response.json();
};`}
          </PulseCode>
          <h3>Without Line Numbers</h3>
          <PulseCode showLineNumbers={false}>
            {`const greeting = "Hello, World!";
console.log(greeting);`}
          </PulseCode>
        </div>
      </section> */}

      <section className="debug-section">
        <h2>Debug Settings</h2>
        <div className="debug-settings">
          <div className="setting-row">
            <PulseCheckbox
              checked={enableLogging}
              value={enableLogging}
              onChange={() => dispatch(setEnableLogging(!enableLogging))}
              label="Enable Logging"
            />
          </div>
          <div className="setting-row">
            <PulseCheckbox
              checked={disableAuthRedirect}
              value={disableAuthRedirect}
              onChange={() =>
                dispatch(setDisableAuthRedirect(!disableAuthRedirect))
              }
              label="Disable Auth Redirect"
            />
          </div>
        </div>
      </section>

      <section className="debug-section">
        <h2>Icons for review</h2>
        <h3>
          Once all are singed off we should promote them to the Design system
          and prefix them with Pulse
        </h3>
        <div className="icons-showcase">
          {Object.entries(Icons).map(([name, Icon]) => (
            <div key={name} className="icon-item">
              <Icon />
              <span className="icon-name">{name}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default DebugPage;
